/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import * as serviceWorker from './serviceWorker';
import PlatformAdminUIContainer from './PlatformAdminUI.container';
import { Route, Router, Switch } from 'react-router-dom';
import './index.css';
import history from './history';
import { isLocal } from './shared/utils/EnvironmentSettings';
import PrototypesRoutingContainer, { PROTOTYPES_URL } from './prototypes/PrototypesRouting.container';
import 'typeface-roboto';
import AuthProvider from './modules/auth/AuthProvider';

const container = document.getElementById('root');
ReactDOM.render(
	<StrictMode>
		<Provider store={store}>
			<AuthProvider>
				<Router history={history}>
					{
						/* Putting the whole switch as conditional since it adds unnecessary complexity to production code */
						isLocal() ? (
							<Switch>
								<Route path={PROTOTYPES_URL}>
									<PrototypesRoutingContainer />
								</Route>
								<Route>
									<PlatformAdminUIContainer />
								</Route>
							</Switch>
						) : (
							<PlatformAdminUIContainer />
						)
					}
				</Router>
			</AuthProvider>
		</Provider>
	</StrictMode>,
	container
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
